import gql from 'graphql-tag';

import type { Content } from '../../card-types';

const StarButtonPageFragment = gql`
	fragment StarButtonPageFragment on ConfluencePage {
		viewer {
			favoritedSummary {
				isFavorite
			}
		}
	}
`;

const StarButtonBlogPostFragment = gql`
	fragment StarButtonBlogPostFragment on ConfluenceBlogPost {
		viewer {
			favoritedSummary {
				isFavorite
			}
		}
	}
`;

const StarButtonWhiteboardFragment = gql`
	fragment StarButtonWhiteboardFragment on ConfluenceWhiteboard {
		viewer {
			favoritedSummary {
				isFavorite
			}
		}
	}
`;

const StarButtonDatabaseFragment = gql`
	fragment StarButtonDatabaseFragment on ConfluenceDatabase {
		viewer {
			favoritedSummary {
				isFavorite
			}
		}
	}
`;

const StarButtonEmbedFragment = gql`
	fragment StarButtonEmbedFragment on ConfluenceEmbed {
		viewer {
			favoritedSummary {
				isFavorite
			}
		}
	}
`;

const StarButtonFolderFragment = gql`
	fragment StarButtonFolderFragment on ConfluenceFolder {
		viewer {
			favoritedSummary {
				isFavorite
			}
		}
	}
`;

type StarButtonFragmentType =
	| typeof StarButtonPageFragment
	| typeof StarButtonBlogPostFragment
	| typeof StarButtonWhiteboardFragment
	| typeof StarButtonDatabaseFragment
	| typeof StarButtonEmbedFragment
	| typeof StarButtonFolderFragment;

const starButtonFragments: Record<Content, StarButtonFragmentType> = {
	page: StarButtonPageFragment,
	blogpost: StarButtonBlogPostFragment,
	whiteboard: StarButtonWhiteboardFragment,
	database: StarButtonDatabaseFragment,
	embed: StarButtonEmbedFragment,
	folder: StarButtonFolderFragment,
};

export const getStarButtonFragment = (type: Content) => starButtonFragments[type];

// For forming the typename correctly for content types to enable optimistic updates
const capitalizedContentTypes: Record<Content, string> = {
	page: 'Page',
	blogpost: 'BlogPost',
	database: 'Database',
	whiteboard: 'Whiteboard',
	embed: 'Embed',
	folder: 'Folder',
};

export const getCapitalizedContentType = (type: Content) => capitalizedContentTypes[type];
